import { create } from 'zustand';
import { FaceLandmarker, FilesetResolver } from '@mediapipe/tasks-vision';

const MEDIAPIPE_WASM_CDN = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.32/wasm';
const FACE_LANDMARKER_MODEL = 'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';

const state = { faceModel: null, isFaceModelReady: false };

const useFaceModel = create((set, get) => ({
  ...state,
  loadFaceModel: async () => {
    if (get().faceModel) return;

    try {
      const filesetResolver = await FilesetResolver.forVisionTasks(MEDIAPIPE_WASM_CDN);
      const faceLandmarker = await FaceLandmarker.createFromOptions(filesetResolver, {
        baseOptions: {
          modelAssetPath: FACE_LANDMARKER_MODEL,
          delegate: 'GPU',
        },
        runningMode: 'VIDEO',
        numFaces: 1,
        outputFaceBlendshapes: false,
      });

      set({ faceModel: faceLandmarker, isFaceModelReady: true });
    } catch (error) {
      console.log(error);
    }
  },
  updateFaceModel: (newState) => set((state) => ({ ...state, ...newState })),
  onResetFaceModel: () => set(() => ({ ...state })),
}));

export default useFaceModel;
